module.exports = __webpack_public_path__ + "static/media/graduation_cap_icon.01dfb2f3.svg";